<template>
  <modal
    id="capture-file-dialog"
    type="notice"
    footer-classes="justify-content-center"
    :show.sync="show"
  >
    <h5
      slot="header"
      class="modal-title"
    >
      Upload a File or Provide Link
    </h5>
    <template>
      <div class="row">
        <div class="col-lg-7 col-md-6">
          <fg-input
            name="filePath"
            readonly
            v-model="fileName"
          />
        </div>
        <div class="col-lg-5 col-md-6 fileinput fileinput-new text-center">
          <div class="btn btn-raised btn-round btn-default btn-file mt-0">
            <span class="fileinput-new">Select File</span>
            <input
              type="file"
              name="..."
              style=""
              @change="processFile($event)"
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <fg-input
            name="linkUrl"
            label="Link URL"
            v-model="url"
          />
        </div>
      </div>
    </template>
    <div
      slot="footer"
      class="justify-content-center"
    >
      <p-button
        type="warning"
        outline
        round
        @click.native="onCancel()"
      >
        Cancel
      </p-button>
      <p-button
        type="success"
        round
        @click.native="onOk()"
      >
        Ok
      </p-button>
    </div>
  </modal>
</template>

<script>
import fileApi from '@/services/api/file'
import Modal from '@/plugins/paper-components/modal.vue'

export default {
  name: 'CaptureFile',
  props: {
    isPhoto: {
      type: Boolean,
      default: null
    }
  },
  components: {
    Modal
  },
  data: function () {
    return {
      url: null,
      file: null,
      show: false,
      tempHolding: null
    }
  },
  computed: {
    fileName: function () {
      if (this.file) {
        return this.file.name
      } else {
        return ''
      }
    },
    acceptFilter: function () {
      if (this.isPhoto === 'true') {
        return 'image/*'
      } else {
        return '*'
      }
    }
  },
  methods: {
    showDialog: function (currentUrl) {
      this.url = currentUrl
      this.file = null
      this.show = true
    },
    hide: function () {
      this.show = false
    },
    processFile: function (event) {
      this.tempHolding = event
      this.file = event.target.files[0]
    },
    onCancel: function () {
      this.hide()
    },
    onOk: function () {
      // Call the api if necessary
      if (this.file !== null && this.isPhoto === true) {
        fileApi
          .uploadPhoto(this.$root.courseKey, this.$root.scouterKey, this.file)
          .then(x => {
            if (x.ResultCode === 'Success') {
              this.$emit('url-captured', x.ResultMessage)
              this.hide()
            } else {
              console.log(x.ResultMessage)
              this.$notify({
                message: x.ResultMessage,
                icon: 'bi bi-exclamation-circle-fill',
                type: 'error',
                horizontalAlign: 'center',
                timeout: 2000
              })
            }
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an error uploading your file.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
          })
          .finally(z => {})
      } else if (this.file !== null && this.isPhoto === false) {
        fileApi
          .uploadFile(this.$root.courseKey, this.file)
          .then(x => {
            if (x.ResultCode === 'Success') {
              this.$emit('url-captured', x.ResultMessage, this.file.name)
              this.hide()
            } else {
              console.log(x.ResultMessage)
              this.$notify({
                message: x.ResultMessage,
                icon: 'bi bi-exclamation-circle-fill',
                type: 'error',
                horizontalAlign: 'center',
                timeout: 2000
              })
            }
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an error uploading your file.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
          })
          .finally(z => {})
      } else {
        this.$emit('url-captured', this.url)
        this.hide()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type="file"] {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
</style>
